<template>
  <div class="content-wrapper">
    <ContentHeader title="Новая заправка" >
      <template slot="additional-header-info" v-if="!isNoCardToOrderOnStart && isQRScannerDevicesEnable">
        <button
          class="btn btn-info bg-darken-3 btn-hover"
          @click="showQRScannerModal('')"><i class="icon-qr-scanner" style="padding-right: 15px;"></i>Сканировать QR-код</button>
      </template>
    </ContentHeader>

    <div class="content-body">
      <card hideHeader hideReload :busy="isBusy">
        <template slot="block">
          <!--div>
            <!- -button @click="showQRScanner">Сканировать QR-код</button- ->
            <button @click="onScan('')">Сканировать QR-код</button>
            
            <!- -qrcode-scanner v-if="isQRScannerVisible" @result="onScan"/- ->
            <p v-if="scannedString">Сосканированная строка: {{scannedString}}</p>
          </div-->
          <div>
            <!--h5>{{ modalStep }} - {{ isNoCardToOrderOnStart }} - {{ isNoCardToOrder }} / {{ quantityPlaceholder }} - {{ f_quantity }} -- {{ m_quantity }}</h5-->
            <h5 v-if="modalStep >= 1">АЗС: <span class="order_info">{{ station.name }}</span></h5>
            <h5 v-if="modalStep >= 2">ТРК: <span class="order_info">{{ trk_num }}</span></h5>
            <h5 v-if="modalStep >= 3">Топливо:  <span class="order_info">{{ fuelForPumpOnStation.name }}</span> цена <span class="order_info">{{ fuelForPumpOnStation.price }} {{getCurrencyName}}</span></h5>
            <h5 v-if="modalStep >= 3 && card.id!=undefined">Топливная карта:  <span class="order_info">{{ card.id }} <span v-if="card.holder_name">- {{ card.holder_name }}</span></span>, карт-счет <span class="order_info">{{ getCardAccName(selectedAccsId) }}</span></h5>
            
            <div v-if="modalStep == 3 && card.id!=undefined" class="purse-content purse-content-info btn-min-width">
                    <i class="icon-box" v-if="pay_method==1"></i>
                    <i class="icon-money" v-if="pay_method==2"></i>
                    <span v-if="pay_method==1"> доступно: <div class="card-volume">{{ cardsLimits[card.id][pay_method].fuel }} л </div></span>
                    <span v-if="pay_method==2"> доступно: <div class="card-volume">{{ cardsLimits[card.id][pay_method].money }} {{ getCurrencyName }} ({{ cardsLimits[card.id][pay_method].fuel}} л)</div></span>
            </div>

            <h5 v-if="modalStep == 10">
              <span v-if="pay_method==1">Объем: <span class="order_info">{{ f_quantity }} л </span>/<span class="order_info"> {{ quantityPlaceholder }} {{ getCurrencyName }}</span></span>
              <span v-if="pay_method==2">Объем: <span class="order_info">{{ f_quantity ? f_quantity : quantityPlaceholder }} л </span>/<span class="order_info"> {{ m_quantity ? m_quantity : quantityPlaceholder }} {{ getCurrencyName }}</span></span>
            </h5>
          </div>
          <hr v-if="modalStep>0"/>
          <div>
            <h4 class="card-title" v-if="!(isNoCardToOrderOnStart || isNoCardToOrder) ">{{slideHeader}}</h4>
          </div>

          <div v-if="modalStep == 0">      <!-- STEP 0 -- SELECT AZS -->
          <template v-if="!isNoCardToOrder">
            <input
              type="text"
              placeholder="Поиск азс"
              class="form-control"
              v-model="station_filter"
              vif="filteredStationsList.length > 3"             
              v-if="getStations.length > 3"
            />
            <div
              v-for="s in filteredStationsList"
              :key="'station_id_' + s.id"
              @click="station_id = s.id; stepNextModal();"
              :style="station_id == s.id ? 'background:red;' : ''"
              class="station-btn"
            >
              <!--{{ s.id }} - {{ s.name }} - {{ s.address }}-->
              {{ s.region_prefix }} - {{ s.name }} <span>- {{ s.address }}</span>
            </div>
            </template>
            <div v-if="isNoCardToOrder">Нет средств для осуществления операции</div>
          </div>
          <div v-if="modalStep == 1">      <!-- STEP 1 -- SELECT A PUMP -->            
            <div v-if="station_id > 0 && station_status == 1" class="pump-wrapper">
              <div
                v-for="pump in getStationsById(station_id).pumps"
                :key="'pump_id_' + pump.id"
                @click=" setTRKNumId(pump.id)"
                :style="trk_num == pump.id ? 'background:red;' : ''"
                class="pump-btn"
                :class="isNoCardToOrder ? 'disabled' : ''"
              >
                {{ pump.id }}
              </div>
              <div v-if="isNoCardToOrder">Нет средств к оплате</div>
            </div>
          </div>
          <div v-if="modalStep == 2">      <!-- STEP 2 -- SELECT A FUEL -->
            <div v-if="station_id > 0 && trk_num > 0" class="pump-wrapper">
              <div
                v-for="fuel in fuelsForPumpOnStation"
                :key="'fuel_id_' + fuel.id"
                @click=" setProductId( fuel.id ) "
                :style="product_id == fuel.id ? 'background:red;' : ''"
                class="pump-btn"
                :class="isNoCardToOrder ? 'disabled' : ''"
              >
                {{ fuel.name }}<!--span> - {{ fuel.price }} {{getCurrencyName}}</span-->
              </div>
              <div v-if="isNoCardToOrder">Нет средств к оплате</div>
            </div>
          </div>
          <div v-if="modalStep == 3">     <!-- STEP 3 -->
            <div v-if="card.id==undefined" class="cards-wrapper"> <!-- выбор карты -->
              <div
                v-for="(cardItem, cardItemIndx) in cardsToSelect"
                :key="'card_id_' + cardItem.id"                
                :style="card.id == cardItem.id ? 'background:red;' : ''"
                class="card-wrapper"
              >
                <div class="card-acc-name">{{ getCardAccName(cardItem.account_id) }}</div> 
                <div class="card-name">{{cardItemIndx + " - " + cardItem.id }}<span v-if="cardItem.holder_name"><br />{{ cardItem.holder_name }}</span></div>
                <div class="purse-wrapper">
                  <div v-for="(item, key) in cardsLimits[cardItem.id]" :key="'purse_' + key"
                    _click="card = cardItem; pay_method = key; setCardId(cardItem, key); "
                    @click="setCardId(cardItem, key); "
                    class="purse-content"
                    :class=" key==1&&item.fuel==0 || key==2&&item.money==0 || item.confirm==0 
                      ? 'purse-content-disabled'
                      : 'btn-min-width bg-blue bg-darken-2 btn-hover'"
                  > 
                    <i class="icon-box" v-if="key==1"></i>
                    <i class="icon-money" v-if="key==2"></i>
                    <span v-if="key==1"> {{item.fuel>0 ? 'доступно: ' : '--'}}  <div class="card-volume" v-if="item.fuel>0">{{ item.fuel }} л </div></span>
                    <span v-if="key==2 && item.money>0"> доступно: <div class="card-volume">{{ item.money }} {{ getCurrencyName }} ({{ item.fuel}} л)</div></span>
                    <div v-if="item.confirm==0" class="card-disabled-info">Нет доступных операций</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="card.id!=undefined && pay_method!=undefined">
              <div class="row">                
                <div class="col-sm-5">
                  <div class="o-input-group" :class="f_error!='' ? 'invalid' : ''">
                    <input
                      type="number"
                      :placeholder="!m_quantity? 'Введите объем' : quantityPlaceholder"
                      class="form-control o-input-group-form-control"
                      v-model="f_quantity"
                      @change="setFQuantity"
                      @input="checkQuantity"
                      :disabled="m_quantity||(m_quantity!=null&&m_quantity!='')"                      
                    />
                    <div class="input-group-append o-input-group-append">
                      <span class="input-group-text o-input-group-text" id="fuel_quantity">{{getVolumeName}}</span>
                    </div>
                  </div>
                  <div class="input-error">{{ f_error }}</div>
                </div>
                <div class="col-sm-2" style="text-align:center" v-if="pay_method==2"><span>или</span></div>
                <div class="col-sm-5" v-if="pay_method==2">
                  <div class="o-input-group" :class="m_error!='' ? 'invalid' : ''">
                    <input
                      type="number"
                      :placeholder="!f_quantity ? 'Введите сумму' : quantityPlaceholder"
                      class="form-control o-input-group-form-control"
                      v-model="m_quantity"
                      @change="setMQuantity"
                      @input="checkQuantity"
                      aria-describedby="fuel_quantity"
                      :disabled="f_quantity||(f_quantity!=null&&f_quantity!='')"
                    />
                    <div class="input-group-append o-input-group-append">
                      <span class="input-group-text o-input-group-text" id="fuel_quantity">{{getCurrencyName}}</span>
                    </div>
                  </div>
                  <div class="input-error">{{ m_error }}</div>                  
                </div>
              </div>
            </div>
          </div>

          <div v-if="modalStep == 10 && order_status != undefined"> <!-- STEP 10 -- ORDER STATUS -->
            <div v-if="order_status.status > 3" style="color: red;">
              Создание заказа невозможно: {{ newOrderCreateStatus }}
            </div>
            <div v-if="order_status.status <= 3">
              {{ newOrderCreateStatus }}
            </div>
            <div class="form-group" v-if="order_status.status <= 3">
              <div class="row">                
                <div class="col-sm-6">
                  <div class="o-input-group">
                    <input
                      type="number"
                      class="form-control o-input-group-form-control o-order-progress-info"
                      style="max-width: 200px"
                      v-model="order_status.quantity"
                      disabled
                    />
                    <div class="input-group-append o-input-group-append">
                      <span class="input-group-text o-input-group-text" id="fuel_quantity">{{getVolumeName}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="o-input-group">
                    <input
                      type="number"
                      class="form-control o-input-group-form-control o-order-progress-info"
                      style="max-width: 200px"
                      v-model="order_status.sum"
                      disabled
                    />
                    <div class="input-group-append o-input-group-append">
                      <span class="input-group-text o-input-group-text" id="fuel_quantity">{{getCurrencyName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </template>
        <template slot="footer">
          <div class="row">
            <div class="col-xs-2 col-sm-6">
              <div class="float-xs-center">
                <button
                  @click="stepBackModal"
                  v-if="modalStep!=0 || (modalStep==10 && order_status.status>3)"
                  class="btn btn-default btn-hover"
                  style="margin-right: 10px;"
                > Назад
                </button>
              </div>
            </div>
            <div class="col-xs-10 col-sm-6">
              <div class="float-xs-right">
                <router-link to="/">
                  <button
                      @click="closeNewOrder"
                      class="btn btn-default btn-hover"
                      path="/orders"
                  >{{ modalStep == 10 ? 'Закрыть' : 'Отмена' }}
                  </button>
                </router-link>
                <button
                    class="btn btn-success bg-green bg-darken-3 btn-hover"
                    @click="createOrder"
                    v-if="modalStep==3&&card.id!=undefined&&pay_method!=undefined"
                    style="margin-left: 10px;"
                    :disabled="f_error!=''||m_error!=''||!(f_quantity||m_quantity)"
                >Создать заказ
                </button>
                <button
                    class="btn btn-success bg-green bg-darken-3 btn-hover"
                    @click="createOrder"
                    v-if="modalStep==10&&order_status.status>3"
                    style="margin-left: 10px;"
                >Повторить заказ
                </button>
              </div>
            </div>
          </div>
        </template>
      </card>
      <modal
        v-if="isQRScannerModalVisible && isQRScannerDevicesEnable"
        @close="closeQRScannerModal()"
        @ok="onScan()"
        
        :showOkButton="isDevelopMode"
        :showCancelButton="false"
      >
      <template slot="header-title">Считайте QR-код</template>
      <template slot="body">
        <div v-if="isDevelopMode">is develop mode: {{ isDevelopMode }}</div>
        <qrcode-scanner @result="onScan" v-if="!isDevelopMode && isQRScannerDevicesEnable"/>
      </template>
      </modal>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import { STATIONS_REQUEST, STATIONSTATUS_REQUEST } from "@/store/actions/stations";
import { CARDS_REQUEST, CARDS_BALANCE_REQUEST } from "@/store/actions/cards";
import { ORDERS_NEW_REQUEST, ORDER_STATUS_REQUEST } from "@/store/actions/orders";
import QrcodeScanner from '@/components/qrcode-scanner.vue';
import modal from "@/components/modal.vue";

import { Html5Qrcode } from "html5-qrcode";

//import { timeStamp } from "console";

export default {
  name: "NewOrder",
  components: {
    ContentHeader,
    card,
    QrcodeScanner,
    modal,
  },
  data() {
    return {
      card: {},
      station_id: null,
      station_status: -1,
      product_id: null,
      trk_num: null,
      f_quantity: null, // кол-во топлива
      m_quantity: null, // сумма заправки
      pay_method: null,

      availableToOrder: {}, // доступные для заказа по литровому и денежному кошельку с учетом лимитов карты

      cardsToSelect: [],
      cardsLimits: {}, // keys - card ids

      f_error: '', // ошибка ввода - превышение доступного лимита
      m_error: '',

      //isBusy: false, //флаг занятости окна при запросах на сервер

      station_filter: '',

      modalStep: 0,

      order_status: undefined,
      newOrderCreateStatus: '',

      orderStatusList: {
        0: "Заказ принят",
        1: "Заказ передан на станцию",
        2: "Заказ подтверждён оператором / начат отпуск",
        3: "Заказ завершен",
        400: "Заказ отменён сервером",
        401: "Нет связи с АЗС",
        402: "На ТРК уже есть заказ",
        500: "Заказ отменён АЗС",
        501: "ТРК занята",
        502: "Нет связи с ТРК",
        503: "ТРК неисправна",
        504: "Недостаточно топлива",
        505: "Введены неверные параметры",
        506: "На АЗС внешние заказы отключены, обратитесь к оператору",
        507: "На АЗС закрыта смена, обратитесь к оператору",
        508: "На АЗС истекла смена, обратитесь к оператору",
        600: "Заказ отменён оператором",
      },

      isQRScannerVisible: false,
      scannedString: null,
      isQRScannerModalVisible: true,
      isQRScannerDevicesEnable: false,

      isNoCardToOrder: false,      

      isDevelopMode: false,
    };
  },
  computed: {
    ...mapGetters([
      "getCurrencyName",

      //"getCards",
      //"getCardById",
      "getCardsByAccs",
      //"isCardsLoading",

      //"getCardsAccs",
      //"isCardsAccsLoading",  
      
      "isCardsBalanceSucceeded",

      "getCardAccB",
      "getCardAccBalances",
      "getCardAccName",
      //"getCardAccFuelBalance",
      "getCardAccMoneyBalance",
      //"isCardAccFuelEmpty",

      "getStations",
      "getStationsById",
      "stationsOnceLoaded",
      "stationsLoaded",

      "getStationStatus_result",

      "isOrdersNewLoading",
    ]),
    isBusy() { //флаг занятости окна при запросах на сервер
      //return false;
      return this.stationsLoaded == 'loading' || 
              this.getStationStatus_result == 'loading' || 
              this.isOrdersNewLoading == 'loading';
    }, 

    getVolumeName() {
      return 'литры'
    },
    filteredStationsList() {
      if (!this.station_filter)
         return this.getStations;
      let list = [];
      this.getStations.forEach(s => {
          if (s.name.indexOf(this.station_filter)>=0 || (s.address && s.address.indexOf(this.station_filter)>=0))
            list.push(s)
      });
      return list;
    },
    fuelsForPumpOnStation() {
        if (!this.station_id)
            return [];
        if (!this.trk_num)
            return [];
        let s = this.getStationsById(this.station_id);
        let fuels = s.fuels;

        let pump = s.pumps.find( p => p.id == this.trk_num );
        if (!pump || !pump.nozzles)
            return [];

        let fuelList = [];

        pump.nozzles.forEach( n => {
            let fuelItem = fuels.find( ff => ff.id == n.fuel.id);
            if (fuelList.find( ff => ff.id == fuelItem.id ) == undefined )
            fuelList.push( {
                id: fuelItem.id,
                name: fuelItem.name,
                price: fuelItem.price,
            })
        })
        return fuelList;
    },
    station() {
        if (!this.station_id)
            return {name: ''};
        let s = this.getStationsById(this.station_id);
        if (!s)
            return {name: ''};
        
        return s;
    },
    fuelForPumpOnStation() {
        if (!this.station_id)
            return '';
        if (!this.trk_num)
            return '';
        if (!this.product_id)
            return '';
        let s = this.getStationsById(this.station_id);
        let fuels = s.fuels;

        let fuel = fuels.find( ff => ff.id == this.product_id);
        return fuel ? fuel : '';
    },
    selectedAccsId() {
      if (this.card.id == undefined)
        return null;

      return this.card.account_id;
    },

    isNextStepAllowed() {
      return (
        this.modalStep == undefined ||
        (this.modalStep == 0 && this.station_id != undefined) ||
        (this.modalStep == 1 && this.trk_num != undefined)
      );
    },
    slideHeader() {
      let header = "Выберите АЗС";
      //let s;
      //if (this.station_id)
      //  s = this.getStationsById(this.station_id);
      switch (this.modalStep) {
        case 1:          
          //header = (s?s.name + ' (' + s.address + ')':'') + ": Выберите ТРК";            
            header = "Выберите ТРК";
            if (this.station_id != undefined)
              if (this.station_status == 2)
                header = "Смена АЗС закрыта. Обратитесь к оператору.";
              if (this.station_status == 3)
                header = "Нет связи со станцией / Нет интернета. Обратитесь к оператору.";
            break;
        case 2:
          header = "Выберите тип топлива";
          break;
        case 3:
          if (!this.card.id)
            header = "Выберите топливную карту и способ оплаты";
          else
            if (this.pay_method == 1)
              header = "Введите объем заправки";
            else if (this.pay_method == 2)
              header = "Введите сумму или объем заправки";
            else
              header = "??"
          break;
        case 10:
          header = "";
      }

      return header;
    },
    quantityPlaceholder() {
      if (this.fuelForPumpOnStation == '')
        return '';
      if (this.m_quantity)
        return (parseFloat(this.m_quantity) / this.fuelForPumpOnStation.price).toFixed(2);
      if (this.f_quantity)
        return (parseFloat(this.f_quantity) * this.fuelForPumpOnStation.price).toFixed(2);
        //return (parseFloat(this.f_quantity)).toFixed(2);
      return '';
    },
    isNoCardToOrderOnStart() { 
      if (this.isCardsBalanceSucceeded)
        return this.checkCardsOnStart();
      else
        return true;
    },
  },
  methods: {
    showModalNewOrder() {
      this.$store.dispatch(CARDS_REQUEST);

      this.modalStep = 0;
      this.station_id = undefined;
      this.showModal = true;
    },

    stepBackModal() {
      if (this.modalStep == 0) this.closeNewOrder();
      else {
        switch (this.modalStep) {
          case 10: 
            this.modalStep = 3;
            this.order_status = undefined;
            this.newOrderCreateStatus = '';
            this.m_quantity = null;
            this.f_quantity = null;
            break;
          case 3:
            if (this.card.id)
            {
              this.card = {};
              this.pay_method = undefined;

              this.f_quantity = undefined;
              this.m_quantity = undefined;
              this.f_error = '';
              this.m_error = '';              
            }
            else
            {
              this.product_id = undefined;
              this.cardsToSelect = [];
              this.cardsLimits = {};           
              this.modalStep--;
            }
            this.isNoCardToOrder = false;
            break;
          case 2:
            this.product_id = undefined;
            this.trk_num = undefined;
            this.isNoCardToOrder = false;
            this.modalStep--;
            break;
          case 1:
            this.product_id = undefined;
            this.trk_num = undefined;
            this.station_id = undefined;
            this.station_status = -1;
            this.isNoCardToOrder = false;
            this.modalStep--;
            break;
          case 0:
            
            break;
        }
        
      }
    },
    stepNextModal() {
      if (this.modalStep < 3) {
        if (this.modalStep == 1) if (this.trk_num == undefined) return;
        if (this.modalStep == 0) if (this.station_id == undefined) return;

//        if (this.modalStep == 1 || this.modalStep == 2 || this.modalStep == 3)
//          if (this.isNoCardToOrder)
//            return;

        this.modalStep++;

        if (this.modalStep == 1 ) // station_id
        {
          // request station state ?
          this.$store.dispatch(STATIONSTATUS_REQUEST, {'id': this.station_id})
            .then( data => { 
              console.log( data.data );
              this.station_status = data.data.status;

              if (this.station_status == 1)
                this.filterCardsByStationFuels( );
            })
            .catch( err => {
              console.log( err );
              this.station_status = -2;
            });
        }

        return;
      }
    },
    checkCardsOnStart() { // проверка доступности карт (отсутствие блокировок) и средств на них (money_enabled || fuel_enabled)
      let usableAccs = [];
      this.getCardAccBalances.forEach( accB => { 
        let isFuel = accB.fuels; // есть какое-то топливо
        if ( isFuel || this.getCardAccMoneyBalance(accB.account_id) ) // топливо или деньги на балансе счета
          usableAccs.push( accB.account_id );
      })

      let cardsToUse = []; // все карты на доступных счетах
      if (usableAccs.length > 0) {
        let cardsList = this.getCardsByAccs( usableAccs );
        cardsList.forEach( item => {
          if (item.block != true) 
          {
            let limits = this.getAvailablesOnCard( item );     // проверим лимиты на карте и их доступность         
            if (item.fuel_enabled && limits[1].fuel > 0
              ||
                item.money_enabled && limits[2].money > 0
            )       
              cardsToUse.push( item );
           }
        })
      }

      if (usableAccs.length <= 0 || cardsToUse.length <= 0)
      {
        this.isNoCardToOrder = true;
        //this.isNoCardToOrderOnStart = true;
        console.log('NO CARDS');

        return true;
      } 

      this.isNoCardToOrder = false;
      return false;     
    },
    filterCardsByStationFuels( trk_num, fuelId ) {
      this.isNoCardToOrder = false;
      
      let product_ids = [];
      let station = this.getStationsById( this.station_id );

      let pumps = station.pumps;
      if (trk_num)
        pumps = [ station.pumps.find(p => p.id == trk_num) ];

      pumps.forEach( pump => {
        pump.nozzles.forEach( n => {
          if (  product_ids.indexOf(n.fuel.id) < 0 )
            product_ids.push( n.fuel.id );
        })
      });
      if (fuelId)
        product_ids = [fuelId];

      let usableAccs = [];
      this.getCardAccBalances.forEach( accB => { 
        let isFuel = false;
        if (accB.fuels)
          isFuel = accB.fuels.find( fuel => product_ids.indexOf( fuel.id ) >= 0 ) != undefined;
        if ( isFuel || this.getCardAccMoneyBalance(accB.account_id) )
          usableAccs.push( accB.account_id );
      })

      let cardsToUse = [];
      if (usableAccs.length > 0) {
        let cardsList = this.getCardsByAccs( usableAccs );
        cardsList.forEach( item => {
          if (item.block != true)
            if (item.fuel_enabled == true || item.money_enabled == true)
              cardsToUse.push( item );
        })
      }

      if (usableAccs.length <= 0 || cardsToUse.length <= 0)
      {
        this.isNoCardToOrder = true;
        console.log('NO CARDS');
      }

    },
    filterCards() {
      let usableAccs = [];
      this.getCardAccBalances.forEach( accB => { 
        let isFuel = false;
        if (accB.fuels)
          isFuel = accB.fuels.find( fuel => fuel.id == this.product_id ) != undefined;
        if ( isFuel || this.getCardAccMoneyBalance(accB.account_id) )
          usableAccs.push( accB.account_id );
      })
      
      this.cardsToSelect = [];
      let cardsList = this.getCardsByAccs( usableAccs );
      cardsList.forEach( item => {
        if (item.block != true)
          if (item.fuel_enabled == true || item.money_enabled == true)
            this.cardsToSelect.push( item );
      })
      this.cardsToSelect.sort( (a, b) => {
        if (parseInt(a.id) > parseInt(b.id))
          return 1;
        else if (parseInt(a.id) < parseInt(b.id))
          return -1;

        return 0;
      })
      // check cards limits 
      this.cardsLimits = {};
      let limits = {};
      this.cardsToSelect.forEach( _card => {
        limits[_card.id] = this.getAvailablesOnCard( _card );
      })
      this.cardsLimits = limits;
    },

    setCardId(card, paymentKey) { // выбор карты
      // проверка лимитов на карте
      // проверка на кошельки карт-счета, если кошелек один - то устанавливаем payMethod
      let limit = this.cardsLimits[card.id]
      if (paymentKey == 1 && limit[paymentKey].fuel <= 0 || 
          paymentKey == 2 && limit[paymentKey].money <= 0)
        return;

      this.card = card;
      this.pay_method = paymentKey;

      let accB = this.getCardAccB( this.selectedAccsId );
      if (!accB || (!accB.money && !accB.fuels))
        return;
      //console.log(accB);
      //if (accB.money != null && accB.fuels == null)
      //  this.pay_method = 2;
      //if (accB.money == null && accB.fuels != null)
      //  this.pay_method = 1;

      // проверка лимитов
      this.availableToOrder[1] = this.getMoneyOnAccs( this.card );
      this.availableToOrder[2] = this.getFuelQuantityOnAccs( this.card );
    },
    setProductId( fuelId ) { // выбор топлива ...
      this.filterCardsByStationFuels(null, fuelId);  
      if (this.isNoCardToOrder)
        return;

      this.product_id = fuelId; 
      this.filterCards(); 
      this.stepNextModal();
    },
    setTRKNumId( trkNum ) { // выбор ТРК ...
      if (this.isNoCardToOrder) // флаг может быть установлен при выборе станции
        return;

      this.filterCardsByStationFuels(trkNum);  

      this.trk_num = trkNum;       
      this.stepNextModal();
    },


    setFQuantity() {
      if (this.f_quantity)
        this.m_quantity = undefined;
    },
    setMQuantity() {
      if (this.m_quantity)
        this.f_quantity = undefined;
    },
    checkQuantity() {
      this.f_error = '';
      this.m_error = ''
      if (this.m_quantity)
      {
        let moneyLimit = this.cardsLimits[this.card.id][2].money;
        console.log(`${this.m_quantity} - ${moneyLimit} - ${this.pay_method == 2 &&
              parseFloat(this.m_quantity) > 0 && parseFloat(this.m_quantity) > moneyLimit}`)
        if (this.pay_method == 2 &&
              parseFloat(this.m_quantity) > 0 && parseFloat(this.m_quantity) > moneyLimit ) 
          this.m_error = 'Превышен лимит доступных средств';
      }
      if (this.f_quantity)
      {        
        let fuelLimit = this.cardsLimits[this.card.id][this.pay_method].fuel;
        
        if ( parseFloat(this.f_quantity) > 0 && parseFloat(this.f_quantity) > fuelLimit )
          this.f_error = 'Превышен лимит';
      }
    },
    closeNewOrder() {
      this.modalStep = 0;
      this.order_status = undefined;
    },
    createOrder() {            
      console.log(ORDERS_NEW_REQUEST);
      let order = {
        card_id: this.card.id,
        station_id: this.station_id,
        product_id: this.product_id,
        pump_id: this.trk_num,
        pay_method: parseInt(this.pay_method), 
        //pay_type_id: 4,
        //terminal_id: 0,
        //quantity : parseFloat(this.pay_method == 1 ? this.f_quantity : this.m_quantity),
      }


      if (this.pay_method == 1)
        order.quantity = parseFloat(this.f_quantity);

      if (this.pay_method == 2)
      {
        if (this.f_quantity)
          order.quantity = parseFloat(this.f_quantity)
        if (this.m_quantity)
          order.sum = parseFloat( this.m_quantity );
      }
      
      /*console.log(order);
      if (1 * 2 + this.pay_method*0 === 2)
        return;*/

      this.$store.dispatch(ORDERS_NEW_REQUEST, order)
        .then(( resp ) => {

          this.order_status = resp.data;
          console.log( resp.data );
          this.modalStep = 10;

          if (this.order_status.status < 3)
            this.checkOrderStatus();
          
          this.newOrderCreateStatus = this.orderStatusList[ this.order_status.status ];
        })
        .catch( (err) => {
          console.log(err);
          
          this.order_status = {status: err.response.status};
          this.modalStep = 10;

          if (err.response.status != 400)
            this.newOrderCreateStatus = 'Ошибка';
          else
          {
            let errorMsg = err.response.data;
            this.newOrderCreateStatus = errorMsg
                ? ( this.orderStatusList[ errorMsg.status ] ? this.orderStatusList[ errorMsg.status ] : errorMsg.error )
                : 'Ошибка';
          }
        })
    },
    checkOrderStatus() {
      console.log('-- checkOrderStatus --')
      console.log(this.order_status);

      if (this.order_status == undefined)
        return;

      let that = this;
      this.$store.dispatch(ORDER_STATUS_REQUEST, { order_guid: this.order_status.guid } )
        .then(( resp ) => {

          let order = resp.data;
          that.order_status = order;

          that.newOrderCreateStatus = that.orderStatusList[ that.order_status.status ];

          if (that.order_status.status < 3)
          {
            console.log('-- next checkOrderStatus --')
            setTimeout( that.checkOrderStatus, 500);
          }
        })
        .catch( (err) => {
          console.log(err);
          this.newOrderCreateStatus = 'Ошибка';
        })
    },

    getFuelQuantityOnAccs( cardItem ) {
      if (!cardItem.fuel_enabled)
        return {fuel: 0 };

      let res = Infinity;
      let accB = this.getCardAccB( cardItem.account_id );
      if (!accB.fuels || accB.fuels.length == 0)
        return {fuel: 0 }

      let fuel = accB.fuels[0]; // первое попавшееся топливо для проверки на старте баланса карты. если хоть какоето топливо есть на балансе то ок
      if (this.product_id)
        fuel = accB.fuels.find( f => f.id == this.product_id );

      if (!fuel)
        return {fuel: 0 }

      let fuelQntOnAccs = 0;
      fuel.quantity.forEach( q => fuelQntOnAccs = fuelQntOnAccs + q );

      if (!this.product_id)
        return {fuel: fuelQntOnAccs};

      let fuelLimitOnCard_target  = cardItem.volume_limit.target_values;
      let fuelLimitOnCard_current = cardItem.volume_limit.current_values;

      function nullToZero( a ) {
        return a==null ? 0 : a;
      }
      let periodItems = ['day', 'week', 'month']; // проверка лимитов
      periodItems.forEach( item => {
        if (fuelLimitOnCard_target[item] != null)
        {
          let periodRes = fuelLimitOnCard_target[item] - nullToZero(fuelLimitOnCard_current[item]);
          //console.log(`${fuelLimitOnCard_target[item]}-${nullToZero(fuelLimitOnCard_current[item])}  ${periodRes}`)
          res = Math.min(res, periodRes)
        }
      })
      // проверка кол-ва операций - null неограниченно, иначе количество оставшихся
      let conf = fuelLimitOnCard_target.confirm;
      if (conf != null)
        conf = conf - nullToZero(fuelLimitOnCard_current.confirm);
      console.log( conf );
      return {fuel: Math.min(res, fuelQntOnAccs), confirm: conf}
    },
    getMoneyOnAccs( cardItem ) {
      if (!cardItem.money_enabled)
        return {money: 0, fuel: 0, confirm: 0}

      function nullToZero( a ) {
        return a==null ? 0 : a;
      }

      let res = Infinity;
      let moneyQntOnAccs = nullToZero(this.getCardAccB( cardItem.account_id ).money);
      console.log(moneyQntOnAccs);

      let moneyLimitOnCard_target  = cardItem.money_limit.target_values;
      let moneyLimitOnCard_current = cardItem.money_limit.current_values;

      let periodItems = ['day', 'week', 'month']; // проверка лимитов
      periodItems.forEach( item => {
        if (moneyLimitOnCard_target[item] != null)
        {
          let periodRes = moneyLimitOnCard_target[item] - nullToZero(moneyLimitOnCard_current[item]);
          //console.log(`${fuelLimitOnCard_target[item]}-${nullToZero(fuelLimitOnCard_current[item])}  ${periodRes}`)
          res = Math.min(res, periodRes)
        }
      })
      res = Math.min(res, moneyQntOnAccs);

      // проверка кол-ва операций - null неограниченно, иначе количество оставшихся
      let conf = moneyLimitOnCard_target.confirm;
      if (conf != null)
        conf = conf - nullToZero(moneyLimitOnCard_current.confirm);

      return {money: res, fuel: (res / this.fuelForPumpOnStation.price).toFixed(2), confirm: conf}
    },
    getAvailablesOnCard( cardItem ) {
      let res = {};

      let fuelAvailables = this.getFuelQuantityOnAccs( cardItem );
      if (fuelAvailables.fuel > 0)
        res[1] = fuelAvailables;
      else
        res[1] = {fuel: 0}

      let moneyAvailables = this.getMoneyOnAccs( cardItem );
      if (moneyAvailables.money > 0 && moneyAvailables.confirm > 0)
        res[2] = moneyAvailables;
      else
        res[2] = {money: 0}

      return res;
    },
    /*showQRScanner(){
      this.scannedString = null;
      this.isQRScannerVisible = true;
    },
    hideQRScanner(){
      this.isQRScannerVisible = false;
    },*/

    showQRScannerModal() {
      this.isQRScannerModalVisible = true;
    },
    closeQRScannerModal() {
      this.isQRScannerModalVisible = false;
    },

    onScan(decodedText, decodedResult){
      let scanJSON = {};

      //decodedText = '{ "optimum": "fueling",  "ver": "1.0",  "client": "bestcompany",  "station_guid": "26901b16-d26f-42e1-8cad-702d23f866de",  "pump_id": 2}';

      function checkDecodedText() {
        let res = true;
        try {
          scanJSON = JSON.parse(decodedText);
        } catch {
          return false;
        }

        if (!scanJSON)
          return false;
        if (!scanJSON.optimum || scanJSON.optimum != "fueling")
          return false;        

        return res;
      }
      if (checkDecodedText()) {

        while (this.modalStep > 0)
          this.stepBackModal();

        let guid = scanJSON.station_guid;
        let pumpId = scanJSON.pump_id;

        if (!guid || !pumpId)
          return false;

        let station, pump;
        station = this.getStations.find(s => s.guid == guid);
        if (!station)
          return;
          
        pump = station.pumps.find(p => p.id == pumpId);

        this.modalStep = 1;
        this.station_id = station.id;

        this.filterCardsByStationFuels();
        
        if (this.modalStep == 1 ) // station_id
        {          
          this.$store.dispatch(STATIONSTATUS_REQUEST, {'id': this.station_id}) // request station state ?
            .then( data => { 
              console.log( data.data );

              this.station_status = data.data.status; // if ok, go on next step with trk num
              if (this.station_status == 1)
              {
                if (pump) {
                  this.modalStep = 2;
                  this.trk_num = pump.id;

                  this.filterCardsByStationFuels();
                }
              }
            })
            .catch( err => {
              console.log( err );
              this.station_status = -2;
            });
        }

        console.log(decodedText, decodedResult);

        this.scannedString = decodedText + station + pump;

        this.closeQRScannerModal();
      }
    },
  },
  created() {
    if (!this.stationsOnceLoaded) this.$store.dispatch(STATIONS_REQUEST);

    //if (!this.cardsOnceLoaded) 
    this.$store.dispatch(CARDS_REQUEST);
    //if (!this.cardsBalancesOnceLoaded)
    this.$store.dispatch(CARDS_BALANCE_REQUEST);


    // This method will trigger user permissions
    Html5Qrcode.getCameras().then(devices => {
      /**
       * devices would be an array of objects of type:
       * { id: "id", label: "label" }
       */
      if (devices && devices.length) {
        //var cameraId = devices[0].id;
        // .. use this to start scanning.
        this.isQRScannerDevicesEnable = true;
      }
    }).catch(err => {
      // handle err
      this.isQRScannerDevicesEnable = false;

      if (this.isDevelopMode)
        this.isQRScannerDevicesEnable = true;      
      console.log(err);
    });   
  },
  mounted() {
    this.checkCardsOnStart();
    if (this.isNoCardToOrderOnStart)
      this.isQRScannerModalVisible = false;
  }
};
</script>

<style>
.station-btn {
  padding: 0.5em 1.5em;
  margin: 0.25em;
  border-radius: 0.25em;
  border: solid 0.1em lightgray;
  font-weight: bold;
  background: rgb(211 211 211 / 30%);
}
.station-btn:hover {
  background: lightgray;
}
.station-btn.selected {
  background: yellow;
}
.station-btn span {
  font-weight: normal;
}
.form-control.station-btn {
  margin: 0;
}
.station-btn.disabled {
  background: rgb(211 211 211 / 30%);
  color: #FFF;
  border-color: gainsboro;
}


.pump-wrapper {
    text-align: center;;
}
.pump-btn {
    display: inline-block;
  padding: 0.5em 1.5em;
  margin: 0.5em;
  border-radius: 0.25em;
  border: solid 0.1em lightgray;
  background: rgb(211 211 211 / 30%);
  font-weight: bold;
  text-align: center;
}
.pump-btn:hover {
  background: lightgray;
}
.pump-btn.disabled {
  background: rgb(211 211 211 / 10%);
  color: #dedede;
  border-color: #dedede;
  cursor: not-allowed;
}

.order_info {
  color: red;
  color: #3949ab;
  font-size: 130%;
}

.input_fuel:after {
  content: 'тенге'
}

.o-input-group {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}
.o-input-group-form-control {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;

  text-align: right;
}
.o-input-group-form-control::placeholder {
    text-align: center;
}
.o-input-group-append {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    margin-left: -1px;
}
.o-input-group-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  /*background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;*/
}
.o-input-group > .o-input-group-append > .o-input-group-text {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.o-order-progress-info {
  max-width: 200px;
  background: none !important;
  font-size: xx-large;
  font-weight: bold;
  color: black;
  margin: 2px 0;
}

.card-wrapper {
  padding: 0.5em 0.5em;
  margin: 0.25em auto;
  border-radius: 0.25em;
  border: solid 0.1em lightgray;
  font-weight: bold;
  background: rgb(211 211 211 / 20%); 
  max-width: 600px; 
}
.card-wrapper > span {
  font-weight: normal;
}
.card-name {
  color:  #3949ab;
}
.card-acc-name {
  float: right;
}
.card-disabled-info {
  color: rgb(194, 127, 3);
  text-align: center;
  clear: both;
}

.purse-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.purse-content {
  max-width: 400px;
  margin: 0.25em;
  padding: 0.25em;

  border-radius: 0.25em;
  border: solid 0.1em gray;
  background: aquamarine;
  font-weight: normal;
  text-align: left;

  color: #FFF;
}
.purse-wrapper > .purse-content {
  width: 50%;
}
.purse-content-disabled {
  border-color: darkgray;
  background: lightgray;
  color: darkgray;
  cursor: not-allowed;
}
.purse-content-info {
  background: none !important;
  color: black;
}

.card-volume {
  float: right;
  font-size: 120%;
  font-weight: bold;
  text-align: right;
}

.o-input-group.invalid > .o-input-group-form-control {
  border-color: red;
}
.input-error {
  color: red;
  text-align: center;
  display: none;
}
.o-input-group.invalid ~ .input-error {
  display: block;
}
</style>
